module.exports = __webpack_public_path__ + "img/733.ab0ef201.jpg";